/* eslint-disable angular/window-service */

;(function () {
  'use strict'

  angular.module('contrast.auth').provider('AuthOptions', AuthOptions)

  function AuthOptions() {
    this.options = {
      resolve: {
        featureFlagsResolve: [
          '$q',
          '$rootScope',
          'FEATURE_FLAGS_LOADED_EVENT',
          function ($q, $rootScope, FEATURE_FLAGS_LOADED_EVENT) {
            return $q(function (resolve) {
              // TODO: CONTRAST-18296
              // eslint-disable-next-line angular/on-watch
              $rootScope.$on(FEATURE_FLAGS_LOADED_EVENT, resolve)
            })
          }
        ],
        auth: [
          '$routeSegment',
          'AuthService',
          function ($routeSegment, AuthService) {
            return AuthService.isUserActive($routeSegment.name)
          }
        ],
        current_organization: [
          '$location',
          '$routeSegment',
          '$q',
          '$routeParams',
          '$rootScope',
          'AuthService',
          'permissions',
          'ProfileFactory',
          'UserService',
          'ProfileService',
          'SurveyService',
          'LoginService',
          'pendoService',
          function (
            $location,
            $routeSegment,
            $q,
            $routeParams,
            $rootScope,
            AuthService,
            permissions,
            ProfileFactory,
            UserService,
            ProfileService,
            SurveyService,
            LoginService,
            pendoService
          ) {
            var deferred = $q.defer()

            if ($routeParams.orgUuid) {
              ProfileFactory.getOrganization($routeParams.orgUuid)
                .then(function (response) {
                  var data = response.data.organization
                  UserService.setCurrentOrganization(data, { broadcast: false })
                  UserService.setEnterprise(response.data.enterprise)

                  var permissionList = []
                  for (var i = 0; i < response.data.roles.length; i++) {
                    permissionList.push(response.data.roles[i])
                  }
                  permissions.setPermissions(permissionList)
                  $rootScope.$broadcast('organization:loaded', data)
                })
                .then(permissions.getUserAccess)
                .then(permissions.getUserPreferences)
                .then(function () {
                  deferred.resolve({ authenticated: true })

                  // Show new user onboarding page the first time the user logs in
                  if (
                    ProfileService.getNewUserOnboardingPreference() &&
                    !permissions.isImpersonating() &&
                    $routeSegment.name.indexOf('newUser') < 0
                  ) {
                    $location.path(UserService.buildUrl('/newuser'), true)
                    return $q.resolve()
                  }

                  // Show the survey advertisement the 2nd time the user logs in
                  if (
                    LoginService.isAfterFirstLogin() &&
                    !permissions.isImpersonating() &&
                    $routeSegment.name.indexOf('newUser') == -1
                  ) {
                    return SurveyService.launchSurvey()
                  }

                  pendoService.initializeIfNeeded()
                })
                .catch(function (response) {
                  if (response.status >= 400 && response.status <= 499) {
                    deferred.reject({
                      authenticated: false,
                      path: $routeSegment.name
                    })
                    AuthService.setAuthenticated(false)
                  } else if (
                    response.status == 301 ||
                    response.status == 303 ||
                    response.status == 307
                  ) {
                    deferred.resolve({ authenticated: true })
                    AuthService.setAuthenticated(true)
                  } else {
                    deferred.reject({
                      authenticated: true,
                      path: $routeSegment.name,
                      network_error: true
                    })
                  }
                })
            } else {
              deferred.resolve({ authenticated: true })
            }

            return deferred.promise
          }
        ]
      },
      untilResolved: {
        template: ''
      },
      resolveFailed: {
        controller: [
          '$scope',
          '$location',
          'logger',
          'error',
          function ($scope, $location, logger, error) {
            if (error.tsv_code) {
              $location.path('/tsv/verification')
            } else if (error.tsv_setup) {
              $location.path('/tsv/setup')
            } else if (error.network_error) {
              logger.logError('There was a network error. Please try again.')
            } else {
              $location.path('/pages/signin')
            }
          }
        ]
      }
    }

    this.$get = function () {
      return new AuthOptions()
    }
  }

  AuthOptions.prototype.buildSecureRouteConfiguration = function (
    url,
    isDefault,
    dependencies,
    resolve
  ) {
    var options = {
      default: isDefault || false,
      dependencies: dependencies || []
    }
    if (typeof url !== 'undefined') {
      options.templateUrl = url
    }
    angular.extend(options, angular.copy(this.options))
    if (resolve) {
      angular.extend(options.resolve, resolve)
    }
    return options
  }

  AuthOptions.prototype.buildSecureRouteConfigurationWithController = function (
    url,
    controller,
    isDefault,
    dependencies,
    resolve
  ) {
    var options = {
      templateUrl: url,
      controller: controller,
      default: isDefault || false,
      dependencies: dependencies || []
    }
    angular.extend(options, angular.copy(this.options))
    if (resolve) {
      angular.extend(options.resolve, resolve)
    }
    return options
  }

  AuthOptions.prototype.buildSecureRouteConfigurationWithParams = function (
    options
  ) {
    return angular.merge(options, angular.copy(this.options))
  }
})()
